import React, { useState } from 'react';
import { Box, Typography, Grid, Tooltip, IconButton } from '@mui/material';
import './HoverCard.css';
import techniqueChecker from '../utils/techniqueChecker';
import Sensual90 from '@mui/icons-material/HistoryToggleOff';

const HoverCard = ({ masseuse }) => {
  const [hover, setHover] = useState(false);

  return (
    <Grid item xs={12} sm={3}>
      <Box
        className="card-container"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        sx={{
          width: 270,
          height: 270,
          position: 'relative',
          overflow: 'hidden',
          cursor: 'pointer',
        }}
      >
        {/* Background Image */}
        <Box
          className="card-background"
          sx={{
            backgroundImage: `url(${
              techniqueChecker(masseuse.technique) ||
              masseuse.name === 'Crystal'
                ? masseuse.image
                : 'https://clubdynasty.ca/wp-content/uploads/2023/01/Female_Silouhette-scaled.jpg'
            })`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            height: '100%',
          }}
        />

        {/* Name and New Tag */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            padding: '10px',
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: hover
              ? 'rgba(195, 137, 43, 0.8)'
              : 'rgba(0, 0, 0, 0.5)',
            zIndex: hover ? 1 : 0,
            transition: 'background 0.3s',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: '#FFF',
              fontWeight: 'bold',
              textTransform: 'uppercase',
            }}
          >
            {masseuse.name}
          </Typography>
          <div>
            {masseuse.new && (
              <Tooltip title="New masseuse">
                <IconButton>
                  <img
                    src="https://clubdynasty.ca/wp-content/uploads/2022/01/new-purple-animation.gif"
                    width="30"
                    alt="New Masseuse"
                  ></img>
                </IconButton>
              </Tooltip>
            )}{' '}
            {masseuse.foot_massage && (
              <Tooltip title="Available for foot massages">
                <IconButton>
                  <img
                    src="https://clubdynasty.ca/wp-content/uploads/2022/11/foot_massage.gif"
                    width="30"
                    alt="Foot Massage"
                  ></img>
                </IconButton>
              </Tooltip>
            )}
            {masseuse.allow_lingam && (
              <Tooltip title="Available for lingam massages">
                <IconButton>
                  <img
                    src="https://clubdynasty.ca/wp-content/uploads/2024/07/lingam_icon.gif"
                    width="30"
                    alt="Foot Massage"
                  ></img>
                </IconButton>
              </Tooltip>
            )}{' '}
            {masseuse.sensual90 && (
              <Tooltip title="Available for 90-minute massages">
                <Sensual90 sx={{ color: 'rgb(255, 140, 26)' }} />
              </Tooltip>
            )}
          </div>
        </Box>

        {/* Hover Details */}
        <Box
          className="hover-details"
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: hover ? '100%' : '0',
            background: 'rgba(0, 0, 0, 0.5)',
            color: '#FFF',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            transition: 'height 0.3s',
          }}
        >
          <div
            style={{
              paddingTop: '20px',
            }}
          >
            {techniqueChecker(masseuse.technique) && (
              <Typography
                variant="body1"
                sx={{
                  marginBottom: '5px',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                }}
              >
                {masseuse.age}
              </Typography>
            )}

            <Typography
              variant="body1"
              sx={{
                marginBottom: '5px',
                fontWeight: 'bold',
                textTransform: 'uppercase',
              }}
            >
              {masseuse.background}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                marginBottom: '5px',
                fontWeight: 'bold',
                textTransform: 'uppercase',
              }}
            >
              {masseuse.measurements}
            </Typography>
          </div>
        </Box>
      </Box>
    </Grid>
  );
};

export default HoverCard;
